import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFService, SFNotification } from 'utils/types';
import css from './ServiceView.scss';
import ServiceProfile from './ServiceProfile';
import ConnectionPlaceholder from '../connectionProfile/ConnectionPlaceholder';
import ScrollToTopOnMount from 'common/ScrollToTopOnMount';
import { isEmpty } from 'lodash';
import ProfileNotFound from '../ProfileNotFound';

export default class ServiceView extends React.Component {

  get content() {
    const { id, service, hasFetched, isServiceMember, isStudent, isStaff } = this.props;
    if ( !hasFetched ) return <ConnectionPlaceholder />;
    if ( isEmpty(service) ) return <ProfileNotFound />;
    return (
      <ServiceProfile
        {...service}
        isServiceMember={isServiceMember}
        isStudent={isStudent}
        isStaff={isStaff}
        id={id}
        canSeeStudentServices={this.props.canSeeStudentServices}
        canMakeAppointment={this.props.canMakeAppointment}
        hasConnectLicense={this.props.hasConnectLicense}
        onFailure={this.props.notification.error}
      />
    );
  }

  render() {
    return (
      <div className={css['container']}>
        <ScrollToTopOnMount />
        {this.props.notification.render()}
        {this.content}
      </div>
    );
  }
}

ServiceView.propTypes = {
  id: SFEntityID.isRequired,
  service: SFService,
  hasFetched: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  notification: SFNotification.isRequired,
  canSeeStudentServices: PropTypes.bool,
  canMakeAppointment: PropTypes.bool,
  hasConnectLicense: PropTypes.bool
};
